import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import axios from 'axios';
import { dv } from '../i18n/dv.ts';

export function ForgotPassword(): JSX.Element {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function submit(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    setPending(true);
    try {
      await axios.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response?.status === 429) {
        setError(dv.common.error);
      } else {
        setError(dv.common.error);
      }
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="mx-auto max-w-sm px-4 py-12">
      <h1 className="font-serif text-3xl tracking-tight mb-2">{dv.auth.resetPassword}</h1>
      <p className="text-sm text-muted-foreground mb-8">
        {dv.auth.forgotPassword}
      </p>
      {sent ? (
        <div className="space-y-4">
          <p className="rounded-lg border border-border bg-paper px-3 py-2.5 text-sm" role="status">
            {dv.auth.resetSent}
          </p>
          <Link to="/login" className="text-sm underline underline-offset-4">{dv.common.back}</Link>
        </div>
      ) : (
        <form className="space-y-3" onSubmit={submit}>
          <input
            className="input"
            type="email"
            dir="ltr"
            aria-label={dv.auth.email}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          {error && <p className="text-sm text-destructive" role="alert">{error}</p>}
          <button
            type="submit"
            disabled={pending}
            className="btn-primary w-full"
          >
            {pending ? dv.common.loading : dv.auth.sendResetLink}
          </button>
          <Link to="/login" className="block text-center text-sm text-muted-foreground underline underline-offset-4">
            {dv.common.back}
          </Link>
        </form>
      )}
    </div>
  );
}
